/*
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

import { ConfirmationDetails, ConfirmationEvent } from '../models/manualEvents/confirmationEvent';

export const noTextTitle = 'Keine Patientenaufklärung';
export const noText = `
  Der Patient ist noch ansprechbar, jedoch in aktuter Lebensgefahr - die Heilbehandlung duldet aber aufgrund der Notfallsituation keinerlei Aufschub.
`;

export const shortTextTitle = 'Kurze Patientenaufklärung';
export const shortText = `
  Guten Tag Herr/Frau (..), Ich bin Dr. (..), der/ die diensthabende Telenotärzt*in. Über eine sichere Verbindung unterstütze ich das Team vor Ort als Arzt, indem ich Video, Ton und Vitalwerte einsehe. Dazu wird das Rettungsdienstpersonal nun Untersuchungen vornehmen, dann werden wir über weitere Schritte entscheiden und ich werde Sie gemeinsam mit dem Rettungsdienst behandeln. Sofern es die Lage erfordert, wird ein Notarzt vor Ort hinzukommen.
`;

export const longTextTitle = 'Lange Patientenaufklärung';
export const longText = `
  Guten Tag Herr/Frau (..), mein Name ist Dr. (..), ich bin der/die Telenotärzt*in und unterstütze das Rettungsdienst Team vor Ort über eine gesicherte Video- und Datenverbindung. Gemeinsam stellen wir sicher, dass Sie die bestmögliche medizinische Versorgung erhalten. Damit ich Sie behandeln kann, benötige ich vorab Ihr Einverständnis in diese Fernbehandlung. Das bedeutet, dass ich Ihre Vitaldaten (wie HF, RR) sowie Video- und Audiodaten einsehen darf um medizinische Entscheidungen zu treffen. Die Behandlung wird nicht aufgezeichnet, wenn Sie nicht einverstanden sind (oder: Die Behandlung wird nicht aufgezeichnet.) Sie ersetzt keinen persönlichen Arztkontakt und unterliegt bestimmten Einschränkungen. Sofern es Ihr Krankheitsbild zulässt, dass ich nicht vor Ort persönlich anwesend sein muss, werde ich Sie gemeinsam mit dem Rettungsdienst vor Ort behandeln. Haben Sie Fragen? Sind Sie damit einverstanden?
`;

export const refusalMedicalTreatmentTextTitle = 'Ablehnung der notfallmedizinischen Behandlung durch den Patienten';
export const refusalMedicalTreatmentText = `
  Hiermit dokumentiere ich, dass Sie (Name) als Patient*in die telenotärztliche Diagnostik und Therapie abgelehnt haben, obwohl sie aus medizinischer Sicht indiziert und erforderlich wäre.  Ich habe Sie dazu über Ihre Erkrankung/Verletzung sowie die Notwendigkeit der Behandlung durch den Telenotarzt vollumfänglich aufgeklärt. Mit der Ablehnung übernehmen Sie die volle Verantwortung für alle sich aus dieser Entscheidung ergebenden gesundheitlichen Folgen und Schäden.
`;

export const refusalTransportTextTitle = 'Transportverweigerung des Patienten';
export const refusalTransportText = `
  Hiermit dokumentiere ich, dass Sie (Name) als Patient*in den Transport in eine geeignete Versorgungseinrichtung (Krankenhaus z.B.), abgelehnt haben. Sie wurden von mir dazu über Ihre Erkrankung/ Verletzung und die Notwendigkeit der weiterführenden Versorgung aufgeklärt. Ich habe Sie insbesondere über mögliche medizinische Folgen (konkret.. bis hin zum Tod) Ihrer Entscheidung, den Transport zu verweigern, vollumfänglich aufgeklärt. Ich habe mich in diesem Arzt- Patienten- Gespräch davon überzeugt, dass Sie die Situation und die Folgen Ihrer Entscheidung vollständig verstanden haben.
`;

export const confirmationEventDetails: ConfirmationDetails = {
  [ConfirmationEvent.confirmationNoPatientEducation]: {
    title: noTextTitle,
    text: noText,
  },
  [ConfirmationEvent.confirmationPatientEducationShort]: {
    title: shortTextTitle,
    text: shortText,
  },
  [ConfirmationEvent.confirmationPatientEducationLong]: {
    title: longTextTitle,
    text: longText,
  },
  [ConfirmationEvent.confirmationRefusalMedicalTreatment]: {
    title: refusalMedicalTreatmentTextTitle,
    text: refusalTransportText,
  },
  [ConfirmationEvent.confirmationRefusalTransport]: {
    title: refusalTransportTextTitle,
    text: refusalTransportText,
  },
} as const;
